import { render, staticRenderFns } from "./changePrice.vue?vue&type=template&id=35213c39&scoped=true"
import script from "./changePrice.vue?vue&type=script&lang=js"
export * from "./changePrice.vue?vue&type=script&lang=js"
import style0 from "./changePrice.vue?vue&type=style&index=0&id=35213c39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35213c39",
  null
  
)

export default component.exports